import { render, staticRenderFns } from "./MetadataPart.vue?vue&type=template&id=56bf9669&"
import script from "./MetadataPart.vue?vue&type=script&lang=ts&"
export * from "./MetadataPart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports